import { useEffect } from 'react'
import type { ReactElement } from 'react'

import Head from 'next/head'

import { CompareOfferBudgeting } from '@ui/components/Content'
import { AdvertiserDisclosure } from '@ui/components/Disclosure'
import { COMPARE_NAV_LINKS } from '@ui/constants'
import { MarketingLayout } from '@ui/layout/MarketingLayout'

import { useEventTracking } from '@website/hooks/useEventTracking'
import { Offer } from '@website/types'

const offers: Offer[] = [
  // {
  //   offer: 'compare-budgeting-atm',
  //   title: 'ATM',
  //   url: '/go?source=%2Fcompare%2Fbudgeting&offer_id=atm',
  // },
  {
    offer: 'compare-budgeting-klover',
    title: 'Klover',
    url: '/go?source=%2Fcompare%2Fbudgeting&offer_id=klover',
  },
  {
    offer: 'compare-budgeting-monarchmoney',
    title: 'Monarch Money',
    url: '/go?source=%2Fcompare%2Fbudgeting&offer_id=monarchmoney',
  },
  {
    offer: 'compare-budgeting-hiatus',
    title: 'Hiatus',
    url: '/go?source=%2Fcompare%2Fbudgeting&offer_id=hiatus',
  },
]

export default function CompareBudgeting() {
  const { trackEvent } = useEventTracking()

  useEffect(() => {
    trackEvent('view_compare_budgeting')
  }, [])

  return (
    <>
      <Head>
        <title>Compare Budgeting Apps - ATM.com</title>
      </Head>
      <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8">
        <div className="flex w-full flex-col gap-4 sm:mt-2 md:flex-row md:justify-between">
          <div className="flex flex-col gap-4">
            <h1 className="font-display text-4xl leading-tight tracking-tight text-[#0a2d4a] md:text-5xl">
              Compare Budgeting Apps
            </h1>
            <p className="text-[19px] leading-[1.4] text-[#0a2d4a]">
              Explore the best budgeting apps to simplify managing your
              finances, track spending, and achieve your financial goals with
              ease.
            </p>
          </div>
          <AdvertiserDisclosure className="leading-tight md:flex-none" />
        </div>
        <div className="mt-6 flex flex-col gap-6">
          {offers.map((offer) => (
            <CompareOfferBudgeting
              key={offer.offer}
              partnerName={offer.offer}
              ctaUrl={offer.url}
              trackEvent={trackEvent}
            />
          ))}
        </div>
      </div>
    </>
  )
}

CompareBudgeting.getLayout = (page: ReactElement) => (
  <MarketingLayout
    bg="light-blue"
    banner={false}
    navLinks={COMPARE_NAV_LINKS}
    showBackButton
  >
    {page}
  </MarketingLayout>
)
